import React from 'react';
import classnames from 'classnames';

import styles from './not-found-error.module.css';
import sharedStyles from '../../sharedStyles.module.css';

type NotFoundErrorProps = {
    title: string;
    message: string;
};

const NotFoundError = ({ title, message }: NotFoundErrorProps) => {
    return (
        <>
            <div
                className={classnames(sharedStyles.boxContainer)}
                data-testid="survey-error-container"
            >
                <div className={styles.textContainer}>
                    <div className={styles.headline}>
                        <h1 className={styles.titleHeadline} data-testid="survey-error-title">
                            {title}
                        </h1>
                    </div>
                    <p className={styles.subHeading} data-testid="survey-error-message">
                        {message} 🤔
                    </p>
                </div>
            </div>
        </>
    );
};

export default NotFoundError;
